import "../../i18n/i18n";
import { VehiclesTable } from "./tables/vehiclesTable";
import { useVehicles } from "./useVehicles";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Spacer } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";

export const FollowDevicesConnectionsTab = () => {
  const { t } = useTranslation();
  const params = useParams();
  const vehiclesListWithId = useVehicles();

  const filteredVehiclesListWithId = useMemo(() => {
    return vehiclesListWithId.filter(
      (v) => v.dataProvider === "FLESPI" && !v.deviceLastActivityDate && v.connectionStatus !== "APPROVED" && v.connectionStatus !== "CONNECTED",
    );
  }, [vehiclesListWithId]);

  if (params.tab !== "followDevicesConnections") {
    return;
  }

  return (
    <StyledContainer>
      <Spacer y={1} />
      <StyledDescription>
        {t("telemetry.followDevicesConnections.description")}
      </StyledDescription>
      <Spacer y={1} />
      <StyledTableContainer>
        <VehiclesTable
          vehiclesListWithId={filteredVehiclesListWithId}
          pageName="vehiclesOfACompany"
          pageTitle={t("telemetry.followDevicesConnections")}
          dataProvider="FLESPI"
          canEditDeviceId
        />
      </StyledTableContainer>
    </StyledContainer>
  );
};

const StyledDescription = styled.div`
  ${typographies["Header/H3"]}
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: hidden;
`;

const StyledTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;